export interface StackFrame {
  raw: string;
  file?: string;
  function?: string;
  line?: number;
  column?: number;
}

export const parseStackTrace = (stackString: string): StackFrame[] => {
  const frames: StackFrame[] = [];
  const lines = stackString.split("\n").filter((line) => line.trim());

  for (const line of lines) {
    const match = line.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)|at\s+(.+?):(\d+):(\d+)/);
    if (match) {
      const frame: StackFrame = {
        raw: line,
        function: match[1] || "anonymous",
        file: match[2] || match[5],
        line: match[3] ? parseInt(match[3]) : match[6] ? parseInt(match[6]) : undefined,
        column: match[4] ? parseInt(match[4]) : match[7] ? parseInt(match[7]) : undefined,
      };
      frames.push(frame);
    } else {
      frames.push({ raw: line });
    }
  }
  return frames;
};
